module.exports = __webpack_public_path__ + "img/prize-03.be6d929a.png";